import React, { Children, cloneElement, PropTypes, PureComponent } from 'react';
import { NOTIFICATION_CONTEXT_TYPES } from '../../../NotificationSystemProvider';
import EmptyState from '../../../common/components/EmptyState';
import PageTabs from '../../../components/layout/PageTabs';
import join from 'url-join';

export default class AdminTourneyBracketList extends PureComponent {
  static contextTypes = {
    dao: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    ...NOTIFICATION_CONTEXT_TYPES
  };

  static propTypes = {
    division: PropTypes.object,
    params: PropTypes.shape({
      tourneyId: PropTypes.string,
      divisionId: PropTypes.string,
      bracketId: PropTypes.string
    }).isRequired
  };

  static defaultProps = {};

  state = {
    brackets: null,
    promise: null
  };

  componentDidMount() {
    this.fetchBrackets(this.props.division);
  }

  componentWillReceiveProps({ division }) {
    if (division.id !== this.props.division.id) {
      this.fetchBrackets(division);
    }
  }

  fetchBrackets = ({ id: divisionId }) => {
    const { dao, onError } = this.context;
    const { promise } = this.state;

    if (!!promise) {
      promise.cancel();
    }

    this.setState({
      brackets: null,
      promise: dao.gameGroups.getAll({ divisionId, sort: 'A|name', type: 'Bracket' })
        .then(
          brackets => this.setState({ brackets }, this.selectFirstBracket)
        )
        .catch(onError)
        .finally(
          () => this.setState({ promise: null })
        )
    });
  };

  selectFirstBracket = () => {
    const { brackets } = this.state;
    const { params: { bracketId } } = this.props;

    if (bracketId) {
      return;
    }

    if (!brackets || brackets.length === 0) {
      return;
    }

    this.selectBracket(brackets[ 0 ]);
  };

  selectBracket = ({ id }) => {
    const { router } = this.context;
    const { params: { tourneyId, divisionId }, location } = this.props;

    router.replace({
      ...location,
      pathname: join('tourneys', tourneyId, 'brackets', divisionId, id)
    });
  };

  render() {
    const { brackets, promise } = this.state;
    const { children, params: { bracketId } } = this.props;

    if (brackets === null) {
      if (promise === null) {
        return EmptyState.ERROR;
      } else {
        return EmptyState.LOADING;
      }
    }

    if (brackets.length === 0) {
      return (<EmptyState>No brackets in this division!</EmptyState>);
    }

    const bracket = bracketId ? _.findWhere(brackets, { id: bracketId }) : null;

    return (
      <div>
        <div style={{ backgroundColor: 'white', paddingTop: 10, borderBottom: '1px solid rgba(0,0,0,0.2)' }}>
          <div className="max-width">
            <PageTabs
              options={brackets.map(({ name }) => name)}
              active={_.indexOf(brackets, bracket)}
              onActiveChange={ix => this.selectBracket(brackets[ ix ])}
            />
          </div>
        </div>
        {
          bracket ?
            Children.map(children, child => cloneElement(child, { bracket })) :
            <EmptyState>Select a bracket</EmptyState>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/GameDay/components/pages/AdminTourneyBracketList.jsx